import React from 'react'
import { isMobile, isDesktop, isIpad } from '../../../global/ScreenSizeHelper'



const CateringMobile = (props) => {
    const { filteredCateringList, handleClickRedirect } = props
    // console.log('----Catering', filteredCateringList)
    return (
        <div>Catering</div>
    )
}

export default CateringMobile